export const reportsGeneratedMsg = bfTranslate('Reports are generated on the 2nd of each month.');